import PublicNav, { PublicFooter } from '@/components/PublicNav';
import GettingStarted from '@/pages/GettingStarted';
import { useState, useEffect } from 'react';
import { landing as landingApi } from '@/lib/api';

export default function GettingStartedPublic() {
  const [footer, setFooter] = useState({});
  useEffect(() => { landingApi.get().then(r => setFooter(r.data?.footer || {})).catch(() => {}); }, []);

  return (
    <div data-testid="getting-started-public" className="light-page min-h-screen bg-white text-slate-900">
      <PublicNav />
      <div className="pt-24 pb-16 px-5 max-w-5xl mx-auto">
        <GettingStarted isPublic />
      </div>
      <PublicFooter footer={footer} />
    </div>
  );
}
